import { Layout, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDispatch } from "react-redux";
import { Rnd } from "react-rnd";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";

import WORK_SPACE from "@assets/images/WORK_SPACE.png";
import { ReactComponent as ICON_ARROW_BACK_MENU } from "@assets/svgs/ICON_ARROW_BACK_MENU.svg";
import { ReactComponent as ICON_IMPORT_ADS_BLOCK } from "@assets/svgs/ICON_IMPORT_ADS_BLOCK.svg";
import { ReactComponent as ICON_IMPORT_DATE } from "@assets/svgs/ICON_IMPORT_DATE.svg";
import { ReactComponent as ICON_IMPORT_PREVIEW } from "@assets/svgs/ICON_IMPORT_PREVIEW.svg";
import { ReactComponent as ICON_IMPORT_STATIC_IMAGE } from "@assets/svgs/ICON_IMPORT_STATIC_IMAGE.svg";
import { ReactComponent as ICON_IMPORT_TIME } from "@assets/svgs/ICON_IMPORT_TIME.svg";
import { ReactComponent as ICON_IMPORT_WEATHER } from "@assets/svgs/ICON_IMPORT_WEATHER.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { useSocketContext } from "@contexts/socket/socketContext";
import { DraggableBlock } from "@pages/ImportantBlocksPageV2/DraggableBlock";
import { DraggableBlockWidget } from "@pages/ImportantBlocksPageV2/DraggableBlockWidget";
import { ManageBlock } from "@pages/ImportantBlocksPageV2/ManageBlock";
import { ManageWidgetImage } from "@pages/ImportantBlocksPageV2/ManageWidgetImage";
import { RenderInnerMediaBlock } from "@pages/ImportantBlocksPageV2/RenderInnerMediaBlock";
import { RenderInnerWidget } from "@pages/ImportantBlocksPageV2/RenderInnerWidget";
import { setCampaignPreview } from "@redux/reducers/campaignPreview.reducers";
import { setImportantPreview } from "@redux/reducers/importantPreview.reducers";
import {
  COLOR_DARK,
  COLOR_GREEN,
  COLOR_RED,
  COLOR_WHITE,
} from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { KEY_CAMPAIGNS_ADD } from "@static/PERMISSION_KEY";
import { MENU_SIZE } from "@static/SIZE";
import { getAuthUserPermissions } from "@utils/getAuthUserPermissions";
import { fetchAPI } from "@utils/https/fetchAPI";

const { REACT_APP_WITH_KIOS } = process.env;

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 6px;
  box-sizing: border-box;
`;

const SectionEditor = styled.div`
  display: flex;
  gap: 16px;
  /* height: 100%; */
  height: calc(100% - 54px);
`;

const SectionWorkspace = styled.div`
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// const WorkspaceLayout = styled.div`
//   position: relative;
//   background-image: url(${WORK_SPACE});
//   background-repeat: no-repeat;
//   background-attachment: fixed;
//   background-size: cover;
//   width: 100%;
//   overflow: hidden;
//   height: ${({ height }) => `${window.innerHeight - height}px`};
// `;

const ContainerWorkspace = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ height }) => `${window.innerHeight - height}px`};
  border: 1px solid #e0e2ea;
`;

const ContainerWorkspaceLayout = styled.div`
  width: ${({ isVertical = false }) => (isVertical ? "50%" : "100%")};
  height: 100%;
`;

const WorkspaceLayout = styled.div`
  position: relative;
  background-image: url(${WORK_SPACE});
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  overflow: hidden;
  height: 100%;
`;

const SectionAction = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 15%;
  border-radius: 16px;
  background: #0000000d;
  padding: 1.2%;
  box-sizing: border-box;
`;

const SectionSelectType = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  overflow-x: scroll;
`;

const Line = styled.div`
  height: 100%;
  width: 1px;
  background: rgba(43, 47, 50, 0.2);
  margin-left: 1.2%;
  margin-right: 1.2%;
`;

const SectionImportList = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  gap: 12px;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionImport = styled.div`
  height: 100%;
  border-radius: 16px;
  background: #0000000d;
  overflow: scroll;
`;

const SectionSubmit = styled.div`
  width: 100%;
`;

const ImportButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  aspect-ratio: 1/1;
  gap: 5%;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 20%;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ disabled }) => (disabled ? "not-allow" : "auto")};
`;

const PreviewButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  aspect-ratio: 1/1;
  gap: 5%;
  background: linear-gradient(270deg, #0eb8b8 0%, #1cdbab 100%);
  border-radius: 20%;
  cursor: pointer;
`;

const BlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1%;
  padding: 3%;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
`;

const SectionWorkspaceBlockName = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  background: ${COLOR_WHITE};
  padding: 2px 15px;
  border-radius: 20px;
  border: 1px solid ${COLOR_DARK};
`;

const IMPORT_COMPONENT_TYPE_LIST = [
  {
    label: "Media",
    icon: ICON_IMPORT_ADS_BLOCK,
    type: "ADS_BLOCKS",
    isDisabled: false,
    isWidget: false,
  },
  {
    label: "Image",
    icon: ICON_IMPORT_STATIC_IMAGE,
    type: "STATIC_IMAGE",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    is_use_media_in_project: true,
    mediaId: null,
    attribute: { path: null },
  },
  {
    label: "Time",
    icon: ICON_IMPORT_TIME,
    type: "STATIC_TIME",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    attribute: { format: 12, clockType: "ANALOG" },
  },
  {
    label: "Date",
    icon: ICON_IMPORT_DATE,
    type: "STATIC_DATE",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    attribute: null,
  },
  {
    label: "Weather",
    icon: ICON_IMPORT_WEATHER,
    type: "STATIC_WEATHER",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    attribute: null,
  },
];

const SectionSelectGroup = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
`;

const GROUP_TYPE_LIST = [
  { label: "Media", value: "media-group" },
  { label: "Widget", value: "widget-group" },
];

export default () => {
  const socket = useSocketContext();
  const workspaceLayoutRef = useRef(null);
  const sectionActionRef = useRef(null);
  const sectionMainActionRef = useRef(null);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const permission = getAuthUserPermissions();
  const defaultImportantCampaignBlocks = _.get(location, [
    "state",
    "importantCampaignBlocks",
  ]);

  const defaultImportantCampaignWidgets = _.get(
    location,
    ["state", "importantCampaignWidgets"],
    []
  );
  const locationState = _.get(location, ["state"]);

  const selectedImportantCampaign = _.chain(locationState)
    .omit(["importantCampaignBlocks", "importantCampaignWidgets"])
    .value();

  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
    modalType: null,
  });

  const [selectedWidgetImageIndex, setSelectedWidgetImageIndex] =
    useState(null);

  const [selectedBlock, setSelectedBlock] = useState(null);
  const [sectionActionHeight, setSectionActionHeight] = useState(0);

  const [defaultImportantCampaign, setDefaultImportantCampaign] = useState(
    selectedImportantCampaign
  );

  const [importantCampaignBlocks, setImportantCampaignBlocks] = useState(
    defaultImportantCampaignBlocks
  );

  console.log("importantCampaignBlocks :>> ", importantCampaignBlocks);
  const [importantCampaignWidgets, setImportantCampaignWidgets] = useState(
    defaultImportantCampaignWidgets
  );

  const [workspaceSize, setWorkspaceSize] = useState({ width: 0, height: 0 });
  const important_name = _.get(defaultImportantCampaign, ["important_name"]);
  const importantHeight = _.get(defaultImportantCampaign, ["important_height"]);
  const importantWidth = _.get(defaultImportantCampaign, ["important_width"]);
  const [selectedGroup, setSelectedGroup] = useState(GROUP_TYPE_LIST[0]?.value);

  console.log("selectedBlock :>> ", selectedBlock);

  useEffect(() => {
    if (workspaceLayoutRef.current) {
      const { clientWidth, clientHeight } = workspaceLayoutRef.current;
      setWorkspaceSize({ width: clientWidth, height: clientHeight });
    }

    if (sectionActionRef.current) {
      const actionHeight = sectionActionRef.current.clientHeight;
      setSectionActionHeight(actionHeight);
    }
  }, []);

  const scaleX = _.get(workspaceSize, ["width"]) / importantWidth;
  const scaleY = _.get(workspaceSize, ["height"]) / importantHeight;

  const handleDragStop = ({ index, e, d }) => {
    setSelectedGroup("media-group");
    const scaledX = Math.round(d.x / scaleX);
    const scaledY = Math.round(d.y / scaleY);
    setImportantCampaignBlocks((prev) => {
      const updateImportantCampaignBlocks = _.map(
        prev,
        (blockItem, blockIndex) =>
          blockIndex === index
            ? { ...blockItem, position_x: scaledX, position_y: scaledY }
            : blockItem
      );
      return updateImportantCampaignBlocks;
    });
  };

  const handleResizeStop = ({ index, e, direction, ref, delta, position }) => {
    const newWidth = Math.round(parseFloat(ref.style.width) / scaleX);
    const newHeight = Math.round(parseFloat(ref.style.height) / scaleY);
    const scaledX = Math.round(position.x / scaleX);
    const scaledY = Math.round(position.y / scaleY);
    setImportantCampaignBlocks((prev) => {
      const updateImportantCampaignBlocks = _.map(
        prev,
        (blockItem, blockIndex) =>
          blockIndex === index
            ? {
                ...blockItem,
                width: newWidth,
                height: newHeight,
                position_x: scaledX,
                position_y: scaledY,
              }
            : blockItem
      );
      return updateImportantCampaignBlocks;
    });
  };

  const onHandleAddBlock = () => {
    setSelectedGroup("media-group");
    const unix = dayjs().unix().toString();
    const width = _.get(locationState, ["important_width"]) / 3;
    const height = _.get(locationState, ["important_height"]) / 3;
    const positionX = _.random(0, importantWidth - width);
    const positionY = _.random(0, importantHeight - height);
    const updateBlock = {
      id: uuidv4(),
      block_key: uuidv4(),
      important_campaign_id: _.get(locationState, ["important_id"]),
      name: `ID-${unix}`,
      width,
      height,
      position_x: positionX,
      position_y: positionY,
      importantCampaignBlockMedias: [],
    };
    setImportantCampaignBlocks((prev) => [{ ...updateBlock }, ...prev]);
  };

  // ===========================================================
  // widget
  const onHandleAddWidget = ({ item }) => {
    const type = _.get(item, ["type"]);
    const isDuplicateType = _.chain(importantCampaignWidgets)
      .cloneDeep()
      .find((widgetItem, widgetIndex) => {
        return _.get(widgetItem, ["type"]) === type;
      })
      .value();
    if (isDuplicateType) {
      console.log("duplicate :>> ");
      return;
    }
    // time props rectangle มาด้วย
    setSelectedGroup("widget-group");
    const unix = dayjs().unix().toString();
    const width = _.get(item, ["defaultWidth"]);
    const height = _.get(item, ["defaultHeight"]);
    const positionX = _.random(0, importantWidth - width);
    const positionY = _.random(0, importantHeight - height);
    const updateWidget = {
      id: uuidv4(),
      widget_key: uuidv4(),
      type: _.get(item, ["type"]),
      important_campaign_id: _.get(locationState, ["important_id"]),
      name: `WIDGET-${unix}`,
      width,
      height,
      position_x: positionX,
      position_y: positionY,
      attribute: _.get(item, ["attribute"], null),
    };
    setImportantCampaignWidgets((prev) => [...prev, { ...updateWidget }]);
  };

  const handleDragStopWidget = ({ index, e, d }) => {
    setSelectedGroup("widget-group");
    const scaledX = Math.round(d.x / scaleX);
    const scaledY = Math.round(d.y / scaleY);
    setImportantCampaignWidgets((prev) => {
      const updateImportantCampaignBlocks = _.map(
        prev,
        (blockItem, blockIndex) =>
          blockIndex === index
            ? { ...blockItem, position_x: scaledX, position_y: scaledY }
            : blockItem
      );
      return updateImportantCampaignBlocks;
    });
  };

  const handleResizeStopWidget = ({
    index,
    e,
    direction,
    ref,
    delta,
    position,
  }) => {
    const newWidth = Math.round(parseFloat(ref.style.width) / scaleX);
    const newHeight = Math.round(parseFloat(ref.style.height) / scaleY);
    const scaledX = Math.round(position.x / scaleX);
    const scaledY = Math.round(position.y / scaleY);
    setImportantCampaignWidgets((prev) => {
      const updateImportantCampaignBlocks = _.map(
        prev,
        (blockItem, blockIndex) =>
          blockIndex === index
            ? {
                ...blockItem,
                width: newWidth,
                height: newHeight,
                position_x: scaledX,
                position_y: scaledY,
              }
            : blockItem
      );
      return updateImportantCampaignBlocks;
    });
  };

  const moveBlockWidget = (fromIndex, toIndex) => {
    setImportantCampaignWidgets((prevBlocks) => {
      const updatedList = [...prevBlocks];
      const [movedItem] = updatedList.splice(fromIndex, 1);
      updatedList.splice(toIndex, 0, movedItem);
      return updatedList;
    });
  };

  const onHandleDeleteWidget = (index) => {
    const updatedWidget = _.filter(
      importantCampaignWidgets,
      (filterItem, filterIndex) => {
        return filterIndex !== index;
      }
    );
    setImportantCampaignWidgets(updatedWidget);
  };

  const onHandleUpdateWidgetInputValue = ({ index, name, value }) => {
    const updatedWidgets = _.chain(importantCampaignWidgets)
      .cloneDeep()
      .set([index, name], value)
      .value();
    setImportantCampaignWidgets(updatedWidgets);
  };

  const onHandleUpdateWidgetImage = ({ index, updateData }) => {
    // console.log("index :>> ", index);
    // console.log("updateData :>> ", updateData);

    const updatedWidgets = _.chain(importantCampaignWidgets)
      .cloneDeep()
      .map((widgetItem, widgetIndex) => {
        return index === widgetIndex
          ? { ...widgetItem, ...updateData }
          : widgetItem;
      })
      .value();
    console.log("updatedWidgets :>> ", updatedWidgets);
    setImportantCampaignWidgets(updatedWidgets);
  };

  const onHandleOpenSelectImage = ({ index }) => {
    console.log("object :>> ", { index });
    setSelectedWidgetImageIndex(index);
    setIsModalVisible({ isOpen: true, modalType: "manage-widget" });
  };

  // widget
  // ===========================================================

  const moveBlock = (fromIndex, toIndex) => {
    setImportantCampaignBlocks((prevBlocks) => {
      const updatedList = [...prevBlocks];
      const [movedItem] = updatedList.splice(fromIndex, 1);
      updatedList.splice(toIndex, 0, movedItem);
      return updatedList;
    });
  };

  const onHandleDeleteBlock = (index) => {
    const updatedBlocks = _.filter(
      importantCampaignBlocks,
      (filterItem, filterIndex) => {
        return filterIndex !== index;
      }
    );
    setImportantCampaignBlocks(updatedBlocks);
  };

  const onHandleUpdateBlockInputValue = ({ index, name, value }) => {
    const updatedBlocks = _.chain(importantCampaignBlocks)
      .cloneDeep()
      .set([index, name], value)
      .value();
    setImportantCampaignBlocks(updatedBlocks);
  };

  const onHandleFullFrameBlock = ({ index }) => {
    const updatedBlocks = _.chain(importantCampaignBlocks)
      .cloneDeep()
      .merge({
        [index]: {
          width: importantWidth,
          height: importantHeight,
          position_x: 0,
          position_y: 0,
        },
      })
      .value();
    setImportantCampaignBlocks(updatedBlocks);
  };

  const onHandleOpenModal = ({ item }) => {
    console.log("onHandleOpenModal item :>> ", item);
    setSelectedBlock(item);
    setIsModalVisible({ isOpen: true, modalType: "manage-block" });
  };

  const onHandleSubmit = async () => {
    console.log("id :>> ", defaultImportantCampaign);
    console.log("widgets :>> ", importantCampaignWidgets);
    console.log("importantCampaignBlocks :>> ", importantCampaignBlocks);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/important-campaigns-update-important-block-ads-block-medias",
      isAuth: true,
      data: {
        importantId: _.get(defaultImportantCampaign, ["important_id"]),
        importantCampaignBlocks,
        importantCampaignWidgets,
      },
    });
    console.log("resp :>> ", resp);
    if (_.get(resp, ["status"])) {
      //   // const results = _.chain(resp).get(["result"]).value();
      toast.success("Save Important Campaign Blocks Success.");
      navigate(-1);
      //   Swal.fire({
      //     title: "จะส่ง Content ขึ้นระบบเลยไหม?",
      //     icon: "info",
      //     showCancelButton: true,
      //     confirmButtonColor: COLOR_GREEN,
      //     cancelButtonColor: COLOR_RED,
      //     confirmButtonText: "ok",
      //     cancelButtonText: "cancel",
      //     reverseButtons: true,
      //     customClass: {
      //       title: "custom-font-swal2",
      //       content: "custom-font-swal2",
      //       confirmButton: "custom-font-swal2",
      //       cancelButton: "custom-font-swal2",
      //     },
      //   }).then(async (result) => {
      //     if (result.isConfirmed) {
      //       const sendForce = await fetchAPI({
      //         method: "post",
      //         path: "/api/v1/send-force-sync-by-ads-campaign-id",
      //         isAuth: true,
      //         data: {
      //           advertising_campaign_id: _.get(defaultImportantCampaign, [
      //             "campaign_id",
      //           ]),
      //         },
      //       });
      //       if (REACT_APP_WITH_KIOS === "true") {
      //         socket.emit(
      //           "BACK-OFFICE-SEND-KIOS-VIEW-UPDATE-CONTENT-WITH-CAMPAIGN-ID",
      //           {
      //             campaignId: _.get(defaultImportantCampaign, ["campaign_id"]),
      //           }
      //         );
      //       }

      //       if (_.get(sendForce, ["status"])) {
      //         navigate(-1);
      //       }
      //     } else {
      //       navigate(-1);
      //     }
      //   });
    }
  };

  // ส่วนนี้ ต้อง เอามา order ให้เหมือนเดิมด้วย

  const onHandleCampaignPreview = () => {
    const previewData = {
      id: _.get(defaultImportantCampaign, ["campaign_id"]),
      name: _.get(defaultImportantCampaign, ["important_name"]),
      start_date: _.get(defaultImportantCampaign, ["campaign_start_date"]),
      end_date: _.get(defaultImportantCampaign, ["campaign_end_date"]),
      start_time: "00:00:00",
      end_time: "23:59:59",
      width: _.get(defaultImportantCampaign, ["important_width"]),
      height: _.get(defaultImportantCampaign, ["important_height"]),
      importantCampaignBlocks: _.cloneDeep(importantCampaignBlocks),
      importantCampaignWidgets: _.cloneDeep(importantCampaignWidgets),
    };
    dispatch(setImportantPreview(previewData));
    window.open("/important-manage-preview-campaign", "_blank");
  };

  const isVertical = _.toInteger(importantWidth) < _.toInteger(importantHeight);

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents>
            <SectionMainAction ref={sectionMainActionRef}>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <Button onClick={() => navigate(-1)} padding="0px">
                  <Icon
                    isCursor
                    width={14}
                    height={14}
                    style={{ marginRight: 8 }}
                  >
                    <ICON_ARROW_BACK_MENU />
                  </Icon>
                  <Text fontSize="18px" fontWeight="600">
                    Back
                  </Text>
                </Button>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                }}
              >
                <Text fontSize="18px" fontWeight="600">
                  Important : ({important_name})
                </Text>
                <Text fontSize="18px" fontWeight="600">
                  |
                </Text>
                <Text fontSize="18px" fontWeight="600">
                  W: {importantWidth} , H: {importantHeight}
                </Text>
              </div>
            </SectionMainAction>
            <SectionEditor>
              <SectionWorkspace>
                <ContainerWorkspace height={sectionActionHeight}>
                  <ContainerWorkspaceLayout isVertical={isVertical}>
                    <WorkspaceLayout ref={workspaceLayoutRef}>
                      {_.map(importantCampaignWidgets, (item, index) => {
                        const dimensionsX = _.chain(item)
                          .get(["position_x"])
                          .toInteger()
                          .value();
                        const dimensionsY = _.chain(item)
                          .get(["position_y"])
                          .toInteger()
                          .value();

                        const dimensionsWidth = _.chain(item)
                          .get(["width"])
                          .toInteger()
                          .value();

                        const dimensionsHeight = _.chain(item)
                          .get(["height"])
                          .toInteger()
                          .value();

                        const type = _.get(item, ["type"]);
                        return (
                          <Rnd
                            key={index}
                            default={{
                              x: 0,
                              y: 0,
                              width: importantWidth * scaleX,
                              height: importantWidth * scaleY,
                            }}
                            size={{
                              width: dimensionsWidth * scaleX,
                              height: dimensionsHeight * scaleY,
                            }}
                            position={{
                              x: dimensionsX * scaleX,
                              y: dimensionsY * scaleY,
                            }}
                            minWidth={50 * scaleX}
                            minHeight={50 * scaleX}
                            bounds="parent"
                            onDragStop={(e, d) =>
                              handleDragStopWidget({ index, e, d })
                            }
                            onResizeStop={(
                              e,
                              direction,
                              ref,
                              delta,
                              position
                            ) =>
                              handleResizeStopWidget({
                                index,
                                e,
                                direction,
                                ref,
                                delta,
                                position,
                              })
                            }
                            style={{
                              backgroundColor: "transparent",
                              zIndex: 1000 - index,
                            }}
                          >
                            <RenderInnerWidget index={index} item={item} />
                          </Rnd>
                        );
                      })}

                      {_.map(importantCampaignBlocks, (item, index) => {
                        const dimensionsX = _.chain(item)
                          .get(["position_x"])
                          .toInteger()
                          .value();
                        const dimensionsY = _.chain(item)
                          .get(["position_y"])
                          .toInteger()
                          .value();

                        const dimensionsWidth = _.chain(item)
                          .get(["width"])
                          .toInteger()
                          .value();

                        const dimensionsHeight = _.chain(item)
                          .get(["height"])
                          .toInteger()
                          .value();

                        const firstMediaInBlocks = _.chain(item)
                          .get(["importantCampaignBlockMedias"])
                          .first()
                          .value();

                        return (
                          <Rnd
                            key={index}
                            default={{
                              x: 0,
                              y: 0,
                              width: importantWidth * scaleX,
                              height: importantHeight * scaleY,
                            }}
                            size={{
                              width: dimensionsWidth * scaleX,
                              height: dimensionsHeight * scaleY,
                            }}
                            position={{
                              x: dimensionsX * scaleX,
                              y: dimensionsY * scaleY,
                            }}
                            minWidth={50 * scaleX}
                            minHeight={50 * scaleY}
                            bounds="parent"
                            onDragStop={(e, d) =>
                              handleDragStop({ index, e, d })
                            }
                            onResizeStop={(
                              e,
                              direction,
                              ref,
                              delta,
                              position
                            ) =>
                              handleResizeStop({
                                index,
                                e,
                                direction,
                                ref,
                                delta,
                                position,
                              })
                            }
                            style={{
                              backgroundColor: "rgba(0, 0, 0, 0.50)",
                              zIndex: 900 - index,
                            }}
                          >
                            <SectionWorkspaceBlockName>
                              <Text
                                fontSize={isVertical ? "10px" : "14px"}
                                fontWeight="500"
                              >
                                {_.get(item, ["name"])}
                              </Text>
                            </SectionWorkspaceBlockName>
                            <RenderInnerMediaBlock
                              index={index}
                              width={dimensionsWidth * scaleX}
                              height={dimensionsHeight * scaleY}
                              firstMediaInBlocks={firstMediaInBlocks}
                            />
                          </Rnd>
                        );
                      })}
                    </WorkspaceLayout>
                  </ContainerWorkspaceLayout>
                </ContainerWorkspace>

                <SectionAction ref={sectionActionRef}>
                  <SectionSelectType>
                    {_.map(IMPORT_COMPONENT_TYPE_LIST, (item, index) => {
                      const RenderIcon = _.get(item, ["icon"]);
                      const isDisabled = _.get(item, ["isDisabled"], false);
                      const isWidget = _.get(item, ["isWidget"], false);
                      const type = _.get(item, ["type"]);

                      const usedWidgets = _.chain(importantCampaignWidgets)
                        .cloneDeep()
                        .map((widget) => {
                          return _.get(widget, ["type"]);
                        })
                        .value();

                      return (
                        <ImportButton
                          key={index}
                          disabled={
                            isWidget
                              ? _.includes(usedWidgets, type)
                              : isDisabled
                          }
                          onClick={() => {
                            isWidget
                              ? onHandleAddWidget({ item })
                              : onHandleAddBlock();
                          }}
                        >
                          <Icon width={"30%"} height={"30%"} isCursor>
                            <RenderIcon fill="#5E6366" />
                          </Icon>
                          <Text style={{ fontSize: "95%" }} color="#5E6366">
                            {_.get(item, ["label"])}
                          </Text>
                        </ImportButton>
                      );
                    })}
                  </SectionSelectType>
                  <Line></Line>
                  <PreviewButton onClick={() => onHandleCampaignPreview()}>
                    <Icon width={"30%"} height={"30%"} isCursor>
                      <ICON_IMPORT_PREVIEW />
                    </Icon>
                    <Text style={{ fontSize: "95%" }} color={COLOR_WHITE}>
                      Preview
                    </Text>
                  </PreviewButton>
                </SectionAction>
              </SectionWorkspace>
              <SectionImportList>
                <SectionSelectGroup>
                  {_.map(GROUP_TYPE_LIST, (item, index) => {
                    const isActive = selectedGroup === item?.value;
                    return (
                      <Button
                        style={{ flex: 1 }}
                        key={index}
                        onClick={() => setSelectedGroup(item?.value)}
                        padding="0px"
                        height={"100%"}
                        color={isActive ? COLOR_GREEN : "#09090905"}
                        border={"0px"}
                      >
                        <Text
                          fontSize="14px"
                          fontWeight="500"
                          color={isActive ? COLOR_WHITE : COLOR_DARK}
                        >
                          {item?.label}
                        </Text>
                      </Button>
                    );
                  })}
                </SectionSelectGroup>
                <SectionImport>
                  <DndProvider backend={HTML5Backend}>
                    {selectedGroup === GROUP_TYPE_LIST[0]?.value && (
                      <BlockContainer>
                        {_.map(importantCampaignBlocks, (item, index) => {
                          return (
                            <DraggableBlock
                              key={index}
                              index={index}
                              item={item}
                              moveBlock={moveBlock}
                              importantWidth={importantWidth}
                              importantHeight={importantHeight}
                              onHandleOpenModal={onHandleOpenModal}
                              onHandleUpdateBlockInputValue={
                                onHandleUpdateBlockInputValue
                              }
                              onHandleDeleteBlock={onHandleDeleteBlock}
                              onHandleFullFrameBlock={onHandleFullFrameBlock}
                            />
                          );
                        })}
                      </BlockContainer>
                    )}
                    {selectedGroup === GROUP_TYPE_LIST[1]?.value && (
                      <BlockContainer>
                        {_.map(importantCampaignWidgets, (item, index) => {
                          return (
                            <DraggableBlockWidget
                              key={index}
                              index={index}
                              item={item}
                              moveBlock={moveBlockWidget}
                              importantWidth={importantWidth}
                              importantHeight={importantHeight}
                              onHandleOpenSelectImage={onHandleOpenSelectImage}
                              // onHandleOpenModal={onHandleOpenModal}
                              onHandleUpdateWidgetInputValue={
                                onHandleUpdateWidgetInputValue
                              }
                              onHandleDeleteWidget={onHandleDeleteWidget}
                            />
                          );
                        })}
                      </BlockContainer>
                    )}
                  </DndProvider>
                </SectionImport>

                <SectionSubmit>
                  {_.includes(permission, KEY_CAMPAIGNS_ADD) && (
                    <Button
                      onClick={() => onHandleSubmit()}
                      style={{ width: "100%" }}
                      color={COLOR_GREEN}
                      fontColor={COLOR_WHITE}
                      padding="7px 15px"
                    >
                      Save
                    </Button>
                  )}
                </SectionSubmit>
              </SectionImportList>
            </SectionEditor>
          </InnerContents>
        </Content>
      </Layout>
      <Modal
        style={{ zIndex: 3000 }}
        width={"80%"}
        destroyOnClose={true}
        title={`${_.chain(selectedBlock)
          .get(["name"])
          .toUpper()
          .thru((block) => {
            const isBlock =
              _.get(isModalVisible, ["modalType"]) === "manage-block";
            return isBlock ? `Block ${block}` : `Widget Image`;
          })
          .value()}`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() =>
          setIsModalVisible((prev) => ({ ...prev, isOpen: false }))
        }
      >
        {_.get(isModalVisible, ["modalType"]) === "manage-block" && (
          <ManageBlock
            setIsModalVisible={setIsModalVisible}
            importantCampaignBlocks={importantCampaignBlocks}
            setImportantCampaignBlocks={setImportantCampaignBlocks}
            importantData={selectedImportantCampaign}
            selectedBlock={selectedBlock}
            importantCampaignBlockMedias={_.get(selectedBlock, [
              "importantCampaignBlockMedias",
            ])}
          />
        )}

        {_.get(isModalVisible, ["modalType"]) === "manage-widget" && (
          <ManageWidgetImage
            setIsModalVisible={setIsModalVisible}
            widgetIndex={selectedWidgetImageIndex}
            onHandleUpdateWidgetImage={onHandleUpdateWidgetImage}
          />
        )}
      </Modal>
    </Layout>
  );
};
